import _ from "lodash";

const groupMetadataByScopeAndTag = (metadata) => {
  const groupedAspectsByScope = _.groupBy(metadata, (aspect) => aspect.scope);

  const groupedMetadata = _.forEach(groupedAspectsByScope, (value, key) => {
    groupedAspectsByScope[key] = _.groupBy(
      groupedAspectsByScope[key],
      (aspect) => {
        return aspect.tag;
      }
    );
  });

  // We add price to all scope because we need it to render in ScenarioTotalsCardComponent
  groupedMetadata.all.price = groupedMetadata["custom-projection"]?.price;

  return groupedMetadata;
};

export default groupMetadataByScopeAndTag;
